import { baseApiClient } from "data/modules/api/api.client";
import { api } from "data";

/**
 * Performs HSN code lookup.
 * @param {string} searchParams - The search keyword/code.
 * @returns {Promise<{ data: HsnResponse }>} The API response data.
 */
export const getHsnData = async (searchParams) => {
  const response = await baseApiClient.get(api.get_hsn_data, {
    params: { search: searchParams },
  });
  return response.data;
};

/**
 * Updates invoice details.
 * @param {UpdateInvoiceDetailsPayload} payload - The update payload.
 * @returns {Promise<any>}
 */
export const updateInvoiceDetails = async (payload) => {
  const response = await baseApiClient.post(
    api.invoice_details_update,
    payload
  );
  return response;
};

/**
 * Initiates a refund.
 * @param {InitiateRefundPayload} payload - The refund payload.
 * @returns {Promise<any>}
 */
export const initiateRefund = async (payload) => {
  const response = await baseApiClient.post(
    "payments/initiate/refunds",
    payload
  );
  return response;
};

/**
 * Fetches invoice audit history.
 * @param {string} transactionUuid
 * @returns {Promise<any>}
 */
export const getInvoiceAuditHistory = async (transactionUuid) => {
  const response = await baseApiClient.get(
    "payments/view/invoice/audit/history",
    {
      params: { transaction_uuid: transactionUuid },
    }
  );
  return response;
};

/**
 * Validates refunds calculation.
 * @param {Object} payload - The validation payload.
 * @returns {Promise<any>}
 */
export const validateRefunds = async (payload) => {
  const response = await baseApiClient.post(
    "payments/validate/refunds",
    payload
  );
  return response;
};
